import axios from 'axios';
import PostCache from './PostCache';
import { getBaseUrl } from '../utils';

import GTMHelper from '../Helpers/gtmHelper';

import ReactHtmlParser from 'react-html-parser';

export default class OcaService {
    lease = {};
    loan = {};
    province = "";
    postCache = null;

    constructor() {
        this.postCache = new PostCache(axios);
    }

    /*
        Handle the reqest sent to OCA and has a post cache object to not send the same post multiple times
    */
    async handleRequest(url, data) {
        const cachedUrls = [];  
        this.postCache.setCachedUrls(cachedUrls);

        const requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                'x-requested-with': 'XMLHttpRequest'
            },
            body: JSON.stringify(data)
        };

        // TEMPORARY MESURE UNTIL BNS HAS FOUND THE BUG
       try
       {
            const responseData = await this.postCache.post(url, data, requestOptions);

            window.ocaRetry === undefined || window.ocaRetry === NaN ? window.ocaRetry = 0: window.ocaRetry++;
           
            // Do we have data, if so reset the retry counter 
            if (responseData.data && responseData.data.oca_url.length > 0) {
                window.ocaRetry = 0
                return responseData.data;
            }

            if (window.ocaRetry < 15) {
                const delay = ms => new Promise(res => setTimeout(res, ms));
                console.log('try again because it failed');

                await delay(500);

                return await this.handleRequest(url, data); 
            }
       } catch {
           console.log('try again because it failed');

           return await this.handleRequest(url, data);
       }       
    }

    /*
        build the body to be sent to OCA to retrieve url

       endpoint requirements can be found here...
       https://confluence.uhub.biz/pages/resumedraft.action?draftId=516591718&draftShareId=cf0565da-a3f2-45c0-b0de-811b21a89d2b&
    */
    buildBodyJson(summaryCalculator, financeType) {

        if (!summaryCalculator) {
            return {}
        }

        const default360 = summaryCalculator._selectedExteriorColour['360'];
        const financialInfo = summaryCalculator.FinancialInfo;

        if(financeType === 'loan'){
            return {
                "data": {
                    "payload": {
                        "vehicle":{
                            "year":Number(summaryCalculator.selectedVehicle.year), // consider that half years exists for mazda
                            "make":"Mazda",
                            "model":ReactHtmlParser(sessionStorage.getItem('plainTitle')),
                            "trim":summaryCalculator.selectedVehicle.trim,
                            "imageUrl": `${summaryCalculator._colours.visual.static_content_base_path}${default360.file_path}${default360.filename_prefix}${summaryCalculator._current360Rotation}${default360.filename_suffix}`, // same image as the one on the summary page
                            "buildLink": `https://www.mazda.ca/en/shopping/build-and-price/#/${summaryCalculator._colours.carline.url_slug}/${summaryCalculator._colours.year.url_slug}/`,
                            "msrp":summaryCalculator._ocaService.loan.cashPrice
                        },
                        "tradeIn":{
                            "tradeInValue":summaryCalculator._tradeInValue,
                            "amountOwedOnTrade":0
                        },
                        "loanType": financeType, // lease or loan
                        "language": summaryCalculator._language + "-CA",
                        "loan":{
                            "cashPrice":summaryCalculator._ocaService.loan.cashPrice,
                            "rate": summaryCalculator._ocaService.loan.rate,
                            "term":Number(summaryCalculator._ocaService.loan.term),
                            "payment": Number(summaryCalculator._ocaService.loan.payment),
                            "financeAmount":Number(summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceWithFeesTaxed),
                            "programEndDateTime":summaryCalculator._ocaService.loan.Program_End_datetime,
                            "downPayment": Number(summaryCalculator._ocaService.loan.downPayment),
                            "apr":Number(summaryCalculator._ocaService.loan.apr)
                        }
                    },
                    "expiration": "600s"
                }
            }
        }else{
            return {
                "data": {
                    "payload": {
                        "vehicle":{
                            "year":Number(summaryCalculator.selectedVehicle.year),
                            "make":"Mazda",
                            "model":ReactHtmlParser(sessionStorage.getItem('plainTitle')),
                            "trim":summaryCalculator.selectedVehicle.trim,
                            "imageUrl": `${summaryCalculator._colours.visual.static_content_base_path}${default360.file_path}${default360.filename_prefix}${summaryCalculator._current360Rotation}${default360.filename_suffix}`,
                            "buildLink": `https://www.mazda.ca/en/shopping/build-and-price/#/${summaryCalculator._colours.carline.url_slug}/${summaryCalculator._colours.year.url_slug}/`,
                            "msrp":summaryCalculator._ocaService.lease.sellingPrice
                        },
                        "tradeIn":{
                            "tradeInValue":summaryCalculator._tradeInValue,
                            "amountOwedOnTrade":0
                        },
                        "loanType": financeType, // lease or loan
                        "language": summaryCalculator._language + "-CA",
                        "lease":{
                            "sellingPrice": summaryCalculator._ocaService.lease.sellingPrice,
                            "residualValue": summaryCalculator._ocaService.lease.residualValue,
                            "term":Number(summaryCalculator._ocaService.lease.term),
                            "monthlyDepreciation":summaryCalculator._ocaService.lease.monthlyDepreciation,
                            "totalInterestCost":summaryCalculator._ocaService.lease.totalInterestCost * summaryCalculator._ocaService.lease.term,
                            "interestFactor":summaryCalculator._ocaService.lease.interestFactor,
                            "baseMonthlyPayment":summaryCalculator._ocaService.lease.baseMonthlyPayment * summaryCalculator._ocaService.lease.term,
                            "gstHSTRate":  summaryCalculator._ocaService.lease.gstHSTRate,
                            "gstHSTAmountOnRental": summaryCalculator._ocaService.lease.gstHSTAmountOnRental,
                            "totalMonthlyPayment":summaryCalculator._ocaService.lease.totalMonthlyPayment,
                            "adjustedCapitalizedCost":summaryCalculator._ocaService.lease.adjustedCapitalizedCost,
                            "PSTRate": summaryCalculator._ocaService.lease.PSTRate,
                            "PSTAmount":summaryCalculator._ocaService.lease.PSTAmount,
                            "programEndDateTime":summaryCalculator._ocaService.lease.Program_End_datetime,
                            "downPayment": Number(summaryCalculator._ocaService.lease.downPayment),
                            "apr":Number(summaryCalculator._ocaService.lease.apr.toFixed(2))
                        }
                    },
                    "expiration": "600s"
                }
            }
        }
    }
    
    /*
        Send the data to the retrieval http service and handle some basic status error.
        
        TODO : Handle all the returned error during the refactoring phase
    */
    async sendDataToService(summaryCalculator, financeType) {
        const gtmHelper = new GTMHelper();

        //get current loan/lease vals
        await summaryCalculator.updateSingleLineFromFinancialProvider();

        const url = `${getBaseUrl()}${process.env.REACT_APP_OCA_API_PATH}`;
        const data = this.buildBodyJson(summaryCalculator, financeType);
        const response = await this.handleRequest(url, data);

        if (response.oca_url.length > 0) {
            const hardcodedCid = `cid=mazda-credit-application`;
            const trackingID = document.cookie.split('; _ga=').pop().split(';').shift(); 
            const trackingParam = trackingID.length > 1 ? `&gcid=${trackingID}`:'';
            const bnsParam = `&appid=${response.oca_url.split('/').at(-1)}`;

            const price = financeType === 'loan' ? summaryCalculator.FinancialInfo.calculatedFinance.balanceToFinanceWithFeesWithRebatesTaxed : summaryCalculator.FinancialInfo.calculatedLease.balanceToLeaseWithFeesWithRebatesTaxed
            //gtm tracking
            gtmHelper.setGTM({'action':`OCA - Modal Submit ${financeType === 'loan' ? 'Finance' : 'Lease'}`,'year': data.data.payload.vehicle.year,'model': ReactHtmlParser(summaryCalculator.selectedVehicle.carline), 'trim': data.data.payload.vehicle.trim, 'price' : Math.round(price), 'application ID' : response.oca_url.split('/').at(-1)}, true, false);

            const exitUrl=`${response.oca_url}?${hardcodedCid}${trackingParam}${bnsParam}`;
            setTimeout(() => {
                window.open(exitUrl, '_blank');
            })
        }else{
            console.log('**** FAILED TO SEND DATA TO OCA ****',  response);
        }
    }

}
